module.exports = __webpack_public_path__ + "static/media/Icon_level.745f60f9.svg";